import { useEffect, useState, useRef } from "react";
import { Modal, Typography } from '@mui/material';
import { Button, TextField, Box, Container } from "@mui/material";
import axios from "axios";
import { TableContainer } from "@mui/material";
import BootstrapTable from 'react-bootstrap-table-next'
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter'
import { useNavigate } from "react-router-dom";
import useUser from "../../hooks/useUser";
import { Grid, MenuItem } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import SearchIcon from '@mui/icons-material/Search';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import HomeIcon from '@mui/icons-material/Home';
import ExcelJS from 'exceljs';




const camposDeInteres = ['id_stock_identificado', 'peso_bascula', 'peso_sap'];
const camposDeInteresEdicion = ['cantidad', 'producto', 'proveedor', 'fecha_de_vencimiento', 'no_de_lote', 'peso_factura', 'peso_neto', 'orden_compra', 'razon_social'];
const usuariosAutorizados = [2, 3, 5, 6];

export default function PDS_CC_FR_001() {

    const tablaRef = useRef();
    const navigate = useNavigate();
    const user = useUser();



    const [data, setData] = useState([]);
    const [fechaInicio, setFechaInicio] = useState("");
    const [fechaFin, setFechaFin] = useState("");


    const [openModal, setOpenModal] = useState(false);

    const [selectedRow, setSelectedRow] = useState(null);

    const [openModalEditar, setOpenModalEditar] = useState(false);

    const [selectedRowEditar, setSelectedRowEditar] = useState(null);

    const handleOpenModal = (row) => {

        setSelectedRow(row);
        setOpenModal(true);
    };

    const handleCloseModal = () => {

        setOpenModal(false);
        setSelectedRow(null);
    };

    const handleOpenModalEditar = (row) => {

        setSelectedRowEditar(row);
        setOpenModalEditar(true);
    };

    const handleCloseModalEditar = () => {

        setOpenModalEditar(false);
        setSelectedRowEditar(null);

    };


    const [respuestaProducto, setRespuestaProducto] = useState([]);
    const respuestaProductoArray = []
    const [respuestaSelectedProducto, setRespuestaSelectedProducto] = useState('');

    const [respuestaProveedor, setRespuestaProveedor] = useState([]);
    const respuestaProveedorArray = []
    const [respuestaSelectedProveedor, setRespuestaSelectedProveedor] = useState('');


    if (respuestaProducto?.length > 0) {

        respuestaProducto?.map((item) => {

            respuestaProductoArray.push({ "key": item.id_respuesta, "value": item.desc_respuesta })

        })

    }

    if (respuestaProveedor?.length > 0) {

        respuestaProveedor?.map((item) => {

            respuestaProveedorArray.push({ "key": item.id_respuesta, "value": item.desc_respuesta })

        })

    }

    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
        borderRadius: 2
    };


    const formatearFecha = (fecha) => {
        const [year, month, day] = fecha.split("-");
        return `${day}/${month}/${year}`;
    };
    const verificarUsuario = () => {
        if (!user.codigo_usuario) {
            alert("Debe autenticarse, Redirigiendo...");
            navigate("/login"); // ✅ esto sí funciona
        }

    };
    useEffect(() => {
        verificarUsuario();
    }, []);
    const consultarDatos = () => {

        setData([]);

        const dateInicio = new Date(fechaInicio);
        const dateFin = new Date(fechaFin);

        if (dateInicio <= dateFin) {

            axios.post(`https://centroformularioscixsa.com${user.puerto}/formulario_sin_finalizar/get_formulario_pdsccfr001`, {
                id_formulario: 4,
                fecha_inicio: formatearFecha(fechaInicio),
                fecha_final: formatearFecha(fechaFin)

            })
                .then(response => setData(response.data.resultado))
                .catch(error => alert("Error al obtener los datos:", error))

            if (data?.length == null) {

                alert("No se encontró información para el rango de fechas seleccionado")

            }

            console.log(data)



        } else {

            alert("La fecha inicial no puede ser mayor a la final")
        }


    };


    const guardarCamposRecursivamente = async (campos, index = 0) => {


        if (index >= campos.length) {

            return;
        }

        const campo = campos[index];

        let pregunta = 0;


        if (campos[index] == 'id_stock_identificado') {

            pregunta = 150

        }

        if (campos[index] == 'peso_bascula') {

            pregunta = 152

        }


        if (campos[index] == 'peso_sap') {

            pregunta = 153

        }

        //console.log(pregunta)

        const valor = selectedRow[campo];

        //console.log("valor: " + valor)

        try {
            const response = await fetch(`https://centroformularioscixsa.com${user.puerto}/formulario_sin_finalizar/formulario_nuevo_pregunta`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    id_formulario_realizado: selectedRow.id_formulario_realizado,
                    id_pregunta: pregunta,
                    id_etiqueta_pregunta: selectedRow.id_etiqueta_pregunta_b
                })
            });
            const datos = await response?.json()

            //console.log(datos)


            //console.log(response)

            if (!response.ok) throw new Error(`Error al guardar ${campo}`);

            // console.log(`Campo ${campo} guardado correctamente.`);



        } catch (error) {

            console.error(`Error en campo ${campo}:`, error);

        }



        try {
            const response = await fetch(`https://centroformularioscixsa.com${user.puerto}/formulario_sin_finalizar/formulario_nuevo_respuesta_abierta`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    id_formulario_realizado: selectedRow.id_formulario_realizado,
                    id_pregunta: pregunta,
                    respuesta_abierta: valor,
                    observacion_respuesta: "NO SE INGRESO INFORMACION",
                    id_etiqueta_pregunta: selectedRow.id_etiqueta_pregunta_b
                })
            });

            const datos = await response?.json()

            // console.log(datos)
            //console.log(response)

            if (!response.ok) throw new Error(`Error al guardar ${campo}`);

            // console.log(`Campo ${campo} guardado correctamente.`);
            // Llamada recursiva
            if (pregunta == 153) {
                // alert("Es diferente a 142: " + pregunta);
                consultarDatos();
                //return; // <- esto corta la recursión aquí
            } else {
                await guardarCamposRecursivamente(campos, index + 1);
            }

        } catch (error) {

            console.error(`Error en campo ${campo}:`, error);

        }
    };



    const guardarCamposRecursivamenteEdicion = async (campos, index = 0) => {


        if (index >= campos.length) {

            return;
        }

        const campo = campos[index];

        console.log("campo a guardar: " + campo)

        let pregunta = 0;


        if (campos[index] == 'cantidad') {

            pregunta = 144

            console.log(pregunta)

        }


        if (campos[index] == 'producto') {

            pregunta = 145


            try {
                const response = await fetch(`https://centroformularioscixsa.com${user.puerto}/formulario_sin_finalizar/formulario_nuevo_respuesta_cerrada_act`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        id_formulario_realizado: selectedRowEditar.id_formulario_realizado,
                        id_pregunta: pregunta,
                        id_respuesta: respuestaSelectedProducto,
                        observacion_respuesta: "NO SE INGRESO INFORMACION",
                        id_etiqueta_pregunta: selectedRowEditar.id_etiqueta_pregunta_b
                    })
                });

                const datos = await response?.json()

                console.log(datos)

                if (!response.ok) throw new Error(`Error al guardar ${campo}`);



                // console.log(`Campo ${campo} guardado correctamente.`);
                //  await guardarCamposRecursivamenteEdicion(campos, index + 1); // Llamada recursiva

            } catch (error) {

                console.error(`Error en campo ${campo}:`, error);

            }

        }


        if (campos[index] == 'proveedor') {

            pregunta = 146


            try {
                const response = await fetch(`https://centroformularioscixsa.com${user.puerto}/formulario_sin_finalizar/formulario_nuevo_respuesta_cerrada_act`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        id_formulario_realizado: selectedRowEditar.id_formulario_realizado,
                        id_pregunta: pregunta,
                        id_respuesta: respuestaSelectedProveedor,
                        observacion_respuesta: "NO SE INGRESO INFORMACION",
                        id_etiqueta_pregunta: selectedRowEditar.id_etiqueta_pregunta_b
                    })
                });

                const datos = await response?.json()


                if (!response.ok) throw new Error(`Error al guardar ${campo}`);

                //await guardarCamposRecursivamenteEdicion(campos, index + 1); // Llamada recursiva

            } catch (error) {

                console.error(`Error en campo ${campo}:`, error);

            }

        }


        if (campos[index] == 'fecha_de_vencimiento') {

            pregunta = 147

        }


        if (campos[index] == 'no_de_lote') {

            pregunta = 148

        }


        if (campos[index] == 'peso_factura') {

            pregunta = 151

        }

        if (campos[index] == 'peso_neto') {

            pregunta = 149

        }


        if (campos[index] == 'orden_compra') {

            pregunta = 154

        }


        if (campos[index] == 'razon_social') {

            pregunta = 142

        }



        const valor = selectedRowEditar[campo];

        try {
            const response = await fetch(`https://centroformularioscixsa.com${user.puerto}/formulario_sin_finalizar/formulario_nuevo_respuesta_abierta_act`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    id_formulario_realizado: selectedRowEditar.id_formulario_realizado,
                    id_pregunta: pregunta,
                    respuesta_abierta: valor,
                    observacion_respuesta: "NO SE INGRESO INFORMACION",
                    id_etiqueta_pregunta: selectedRowEditar.id_etiqueta_pregunta_b
                })
            });

            const datos = await response?.json()

            if (!response.ok) throw new Error(`Error al guardar ${campo}`);

            if (pregunta == 142) {
                consultarDatos();

            }
            if (pregunta == 142) {
                // alert("Es diferente a 142: " + pregunta);
                consultarDatos();
                //return; // <- esto corta la recursión aquí
            } else {
                // alert("Es igual a: " + pregunta);
                await guardarCamposRecursivamenteEdicion(campos, index + 1);
            }

        } catch (error) {

            console.error(`Error en campo ${campo}:`, error);

        }



    };

    const customHeader = (column, colIndex, { filterElement }) => {
        return (
            <div>
                {filterElement} {/* Aquí se coloca el filtro sin afectar el encabezado */}
            </div>
        );
    };

    const columns = [

        {
            dataField: 'razon_social',
            text: 'Razón Social',
            sort: true,
            headerStyle: { minWidth: 250, textAlign: 'center' }, // Centra el encabezado
            style: { textAlign: 'center' },
            filter: textFilter({ placeholder: '' }),
            filterRenderer: (onFilter, column) => (
                <div className="form-group" style={{ display: 'flex', flexDirection: 'column' }}>
                    <label htmlFor={`filter-${column.dataField}`} style={{ fontWeight: 'bold', marginBottom: '4px' }}>
                        {column.text}
                    </label>
                    <input
                        id={`filter-${column.dataField}`}
                        type="text"
                        placeholder="Filtrar por Razon Social..."
                        onChange={e => onFilter(e.target.value)}
                        className="form-control"
                    />
                </div>
            ),
            headerFormatter: customHeader,
            footer: ''
        },
        {
            dataField: 'responsable',
            text: 'Nombre Responsable',
            sort: true,
            headerStyle: { minWidth: 250, textAlign: 'center' }, // Centra el encabezado
            style: { textAlign: 'center' },
            filter: textFilter({ placeholder: '' }),
            filterRenderer: (onFilter, column) => (
                <div className="form-group" style={{ display: 'flex', flexDirection: 'column' }}>
                    <label htmlFor={`filter-${column.dataField}`} style={{ fontWeight: 'bold', marginBottom: '4px' }}>
                        {column.text}
                    </label>
                    <input
                        id={`filter-${column.dataField}`}
                        type="text"
                        placeholder="Filtrar por Nombre Responsable..."
                        onChange={e => onFilter(e.target.value)}
                        className="form-control"
                    />
                </div>
            ),
            headerFormatter: customHeader,
            footer: ''
        },
        {
            dataField: 'fecha',
            text: 'Fecha',
            sort: true,
            headerStyle: { minWidth: 250, textAlign: 'center' }, // Centra el encabezado
            style: { textAlign: 'center' },
            filter: textFilter({ placeholder: '' }),
            filterRenderer: (onFilter, column) => (
                <div className="form-group" style={{ display: 'flex', flexDirection: 'column' }}>
                    <label htmlFor={`filter-${column.dataField}`} style={{ fontWeight: 'bold', marginBottom: '4px' }}>
                        {column.text}
                    </label>
                    <input
                        id={`filter-${column.dataField}`}
                        type="text"
                        placeholder="Filtrar por Fecha..."
                        onChange={e => onFilter(e.target.value)}
                        className="form-control"
                    />
                </div>
            ),

            headerFormatter: customHeader,
            footer: ''
        },
        {
            dataField: 'hora',
            text: 'Hora',
            sort: true,
            headerStyle: { minWidth: 250, textAlign: 'center' }, // Centra el encabezado
            style: { textAlign: 'center' },
            filter: textFilter({ placeholder: '' }),
            filterRenderer: (onFilter, column) => (
                <div className="form-group" style={{ display: 'flex', flexDirection: 'column' }}>
                    <label htmlFor={`filter-${column.dataField}`} style={{ fontWeight: 'bold', marginBottom: '4px' }}>
                        {column.text}
                    </label>
                    <input
                        id={`filter-${column.dataField}`}
                        type="text"
                        placeholder="Filtrar por Hora..."
                        onChange={e => onFilter(e.target.value)}
                        className="form-control"
                    />
                </div>
            ),
            headerFormatter: customHeader,
            footer: ''
        },
        {
            dataField: 'no_placa_transporte',
            text: 'No. de Placa Transporte',
            sort: true,
            headerStyle: { minWidth: 250, textAlign: 'center' }, // Centra el encabezado
            style: { textAlign: 'center' },
            filter: textFilter({ placeholder: '' }),
            filterRenderer: (onFilter, column) => (
                <div className="form-group" style={{ display: 'flex', flexDirection: 'column' }}>
                    <label htmlFor={`filter-${column.dataField}`} style={{ fontWeight: 'bold', marginBottom: '4px' }}>
                        {column.text}
                    </label>
                    <input
                        id={`filter-${column.dataField}`}
                        type="text"
                        placeholder="Filtrar por No. de Placa Transporte..."
                        onChange={e => onFilter(e.target.value)}
                        className="form-control"
                    />
                </div>
            ),
            headerFormatter: customHeader,
            footer: ''
        },
        {
            dataField: 'nombre_piloto',
            text: 'Nombre de Piloto',
            sort: true,
            headerStyle: { minWidth: 250, textAlign: 'center' }, // Centra el encabezado
            style: { textAlign: 'center' },
            filter: textFilter({ placeholder: '' }),
            filterRenderer: (onFilter, column) => (
                <div className="form-group" style={{ display: 'flex', flexDirection: 'column' }}>
                    <label htmlFor={`filter-${column.dataField}`} style={{ fontWeight: 'bold', marginBottom: '4px' }}>
                        {column.text}
                    </label>
                    <input
                        id={`filter-${column.dataField}`}
                        type="text"
                        placeholder="Filtrar por Nombre de Piloto..."
                        onChange={e => onFilter(e.target.value)}
                        className="form-control"
                    />
                </div>
            ),
            headerFormatter: customHeader,
            footer: ''
        },

        {
            dataField: 'descargado_por',
            text: 'Descargado Por',
            sort: true,
            headerStyle: { minWidth: 250, textAlign: 'center' }, // Centra el encabezado
            style: { textAlign: 'center' },
            filter: textFilter({ placeholder: '' }),
            filterRenderer: (onFilter, column) => (
                <div className="form-group" style={{ display: 'flex', flexDirection: 'column' }}>
                    <label htmlFor={`filter-${column.dataField}`} style={{ fontWeight: 'bold', marginBottom: '4px' }}>
                        {column.text}
                    </label>
                    <input
                        id={`filter-${column.dataField}`}
                        type="text"
                        placeholder="Filtrar por Descargado Por..."
                        onChange={e => onFilter(e.target.value)}
                        className="form-control"
                    />
                </div>
            ),
            headerFormatter: customHeader,
            footer: ''
        },
        {
            dataField: 'cantidad',
            text: 'Cantidad',
            sort: true,
            headerStyle: { minWidth: 250, textAlign: 'center' }, // Centra el encabezado
            style: { textAlign: 'center' },
            filter: textFilter({ placeholder: '' }),
            filterRenderer: (onFilter, column) => (
                <div className="form-group" style={{ display: 'flex', flexDirection: 'column' }}>
                    <label htmlFor={`filter-${column.dataField}`} style={{ fontWeight: 'bold', marginBottom: '4px' }}>
                        {column.text}
                    </label>
                    <input
                        id={`filter-${column.dataField}`}
                        type="text"
                        placeholder="Filtrar por Cantidad..."
                        onChange={e => onFilter(e.target.value)}
                        className="form-control"
                    />
                </div>
            ),
            headerFormatter: customHeader,
            footer: ''
        },
        {
            dataField: 'producto',
            text: 'Producto',
            sort: true,
            headerStyle: { minWidth: 250, textAlign: 'center' }, // Centra el encabezado
            style: { textAlign: 'center' },
            filter: textFilter({ placeholder: '' }),
            filterRenderer: (onFilter, column) => (
                <div className="form-group" style={{ display: 'flex', flexDirection: 'column' }}>
                    <label htmlFor={`filter-${column.dataField}`} style={{ fontWeight: 'bold', marginBottom: '4px' }}>
                        {column.text}
                    </label>
                    <input
                        id={`filter-${column.dataField}`}
                        type="text"
                        placeholder="Filtrar por Producto..."
                        onChange={e => onFilter(e.target.value)}
                        className="form-control"
                    />
                </div>
            ),
            headerFormatter: customHeader,
            footer: ''
        },
        {
            dataField: 'proveedor',
            text: 'Proveedor',
            sort: true,
            headerStyle: { minWidth: 250, textAlign: 'center' }, // Centra el encabezado
            style: { textAlign: 'center' },
            filter: textFilter({ placeholder: '' }),
            filterRenderer: (onFilter, column) => (
                <div className="form-group" style={{ display: 'flex', flexDirection: 'column' }}>
                    <label htmlFor={`filter-${column.dataField}`} style={{ fontWeight: 'bold', marginBottom: '4px' }}>
                        {column.text}
                    </label>
                    <input
                        id={`filter-${column.dataField}`}
                        type="text"
                        placeholder="Filtrar por Proveedor..."
                        onChange={e => onFilter(e.target.value)}
                        className="form-control"
                    />
                </div>
            ),
            headerFormatter: customHeader,
            footer: ''
        },
        {
            dataField: 'fecha_de_vencimiento',
            text: 'Fecha de Vencimiento',
            sort: true,
            headerStyle: { minWidth: 250, textAlign: 'center' }, // Centra el encabezado
            style: { textAlign: 'center' },
            filter: textFilter({ placeholder: '' }),
            filterRenderer: (onFilter, column) => (
                <div className="form-group" style={{ display: 'flex', flexDirection: 'column' }}>
                    <label htmlFor={`filter-${column.dataField}`} style={{ fontWeight: 'bold', marginBottom: '4px' }}>
                        {column.text}
                    </label>
                    <input
                        id={`filter-${column.dataField}`}
                        type="text"
                        placeholder="Filtrar por Fecha de Vencimiento..."
                        onChange={e => onFilter(e.target.value)}
                        className="form-control"
                    />
                </div>
            ),
            headerFormatter: customHeader,
            footer: ''
        },
        {
            dataField: 'no_de_lote',
            text: 'No. de Lote',
            sort: true,
            headerStyle: { minWidth: 250, textAlign: 'center' }, // Centra el encabezado
            style: { textAlign: 'center' },
            filter: textFilter({ placeholder: '' }),
            filterRenderer: (onFilter, column) => (
                <div className="form-group" style={{ display: 'flex', flexDirection: 'column' }}>
                    <label htmlFor={`filter-${column.dataField}`} style={{ fontWeight: 'bold', marginBottom: '4px' }}>
                        {column.text}
                    </label>
                    <input
                        id={`filter-${column.dataField}`}
                        type="text"
                        placeholder="Filtrar por No. de Lote..."
                        onChange={e => onFilter(e.target.value)}
                        className="form-control"
                    />
                </div>
            ),
            headerFormatter: customHeader,
            footer: ''
        },
        {
            dataField: 'peso_neto',
            text: 'Peso Neto',
            sort: true,
            headerStyle: { minWidth: 250, textAlign: 'center' }, // Centra el encabezado
            style: { textAlign: 'center' },
            filter: textFilter({ placeholder: '' }),
            filterRenderer: (onFilter, column) => (
                <div className="form-group" style={{ display: 'flex', flexDirection: 'column' }}>
                    <label htmlFor={`filter-${column.dataField}`} style={{ fontWeight: 'bold', marginBottom: '4px' }}>
                        {column.text}
                    </label>
                    <input
                        id={`filter-${column.dataField}`}
                        type="text"
                        placeholder="Filtrar por Peso Neto..."
                        onChange={e => onFilter(e.target.value)}
                        className="form-control"
                    />
                </div>
            ),
            headerFormatter: customHeader,
            footer: ''
        },
        {
            dataField: 'id_stock_identificado',
            text: 'Id. Stock Identificado',
            sort: true,
            headerStyle: { minWidth: 250, textAlign: 'center' }, // Centra el encabezado
            style: { textAlign: 'center' },
            filter: textFilter({ placeholder: '' }),
            filterRenderer: (onFilter, column) => (
                <div className="form-group" style={{ display: 'flex', flexDirection: 'column' }}>
                    <label htmlFor={`filter-${column.dataField}`} style={{ fontWeight: 'bold', marginBottom: '4px' }}>
                        {column.text}
                    </label>
                    <input
                        id={`filter-${column.dataField}`}
                        type="text"
                        placeholder="Filtrar por Id Stock Identificado..."
                        onChange={e => onFilter(e.target.value)}
                        className="form-control"
                    />
                </div>
            ),
            headerFormatter: customHeader,
            footer: ''
        },
        {
            dataField: 'peso_factura',
            text: 'Peso Factura',
            sort: true,
            headerStyle: { minWidth: 250, textAlign: 'center' }, // Centra el encabezado
            style: { textAlign: 'center' },
            filter: textFilter({ placeholder: '' }),
            filterRenderer: (onFilter, column) => (
                <div className="form-group" style={{ display: 'flex', flexDirection: 'column' }}>
                    <label htmlFor={`filter-${column.dataField}`} style={{ fontWeight: 'bold', marginBottom: '4px' }}>
                        {column.text}
                    </label>
                    <input
                        id={`filter-${column.dataField}`}
                        type="text"
                        placeholder="Filtrar por Peso Factura..."
                        onChange={e => onFilter(e.target.value)}
                        className="form-control"
                    />
                </div>
            ),
            headerFormatter: customHeader,
            footer: ''
        },
        {
            dataField: 'peso_bascula',
            text: 'Peso Bascula',
            sort: true,
            headerStyle: { minWidth: 250, textAlign: 'center' }, // Centra el encabezado
            style: { textAlign: 'center' },
            filter: textFilter({ placeholder: '' }),
            filterRenderer: (onFilter, column) => (
                <div className="form-group" style={{ display: 'flex', flexDirection: 'column' }}>
                    <label htmlFor={`filter-${column.dataField}`} style={{ fontWeight: 'bold', marginBottom: '4px' }}>
                        {column.text}
                    </label>
                    <input
                        id={`filter-${column.dataField}`}
                        type="text"
                        placeholder="Filtrar por Peso Báscula..."
                        onChange={e => onFilter(e.target.value)}
                        className="form-control"
                    />
                </div>
            ),
            headerFormatter: customHeader,
            footer: ''
        },
        {
            dataField: 'peso_sap',
            text: 'Peso Sap',
            sort: true,
            headerStyle: { minWidth: 250, textAlign: 'center' }, // Centra el encabezado
            style: { textAlign: 'center' },
            filter: textFilter({ placeholder: '' }),
            filterRenderer: (onFilter, column) => (
                <div className="form-group" style={{ display: 'flex', flexDirection: 'column' }}>
                    <label htmlFor={`filter-${column.dataField}`} style={{ fontWeight: 'bold', marginBottom: '4px' }}>
                        {column.text}
                    </label>
                    <input
                        id={`filter-${column.dataField}`}
                        type="text"
                        placeholder="Filtrar por Peso Sap..."
                        onChange={e => onFilter(e.target.value)}
                        className="form-control"
                    />
                </div>
            ),
            headerFormatter: customHeader,
            footer: ''
        },
        {
            dataField: 'orden_compra',
            text: 'Orden Compra',
            sort: true,
            headerStyle: { minWidth: 250, textAlign: 'center' }, // Centra el encabezado
            style: { textAlign: 'center' },
            filter: textFilter({ placeholder: '' }),
            filterRenderer: (onFilter, column) => (
                <div className="form-group" style={{ display: 'flex', flexDirection: 'column' }}>
                    <label htmlFor={`filter-${column.dataField}`} style={{ fontWeight: 'bold', marginBottom: '4px' }}>
                        {column.text}
                    </label>
                    <input
                        id={`filter-${column.dataField}`}
                        type="text"
                        placeholder="Filtrar por Orden Compra..."
                        onChange={e => onFilter(e.target.value)}
                        className="form-control"
                    />
                </div>
            ),
            headerFormatter: customHeader,
            footer: ''
        },
        {
            dataField: 'empaque',
            text: 'Empaque',
            sort: true,
            headerStyle: { minWidth: 250, textAlign: 'center' }, // Centra el encabezado
            style: { textAlign: 'center' },
            filter: textFilter({ placeholder: '' }),
            filterRenderer: (onFilter, column) => (
                <div className="form-group" style={{ display: 'flex', flexDirection: 'column' }}>
                    <label htmlFor={`filter-${column.dataField}`} style={{ fontWeight: 'bold', marginBottom: '4px' }}>
                        {column.text}
                    </label>
                    <input
                        id={`filter-${column.dataField}`}
                        type="text"
                        placeholder="Filtrar por Empaque..."
                        onChange={e => onFilter(e.target.value)}
                        className="form-control"
                    />
                </div>
            ),
            headerFormatter: customHeader,
            footer: ''
        },
        {
            dataField: 'estado',
            text: 'Estado',
            sort: true,
            headerStyle: { minWidth: 250, textAlign: 'center' }, // Centra el encabezado
            style: { textAlign: 'center' },
            filter: textFilter({ placeholder: '' }),
            filterRenderer: (onFilter, column) => (
                <div className="form-group" style={{ display: 'flex', flexDirection: 'column' }}>
                    <label htmlFor={`filter-${column.dataField}`} style={{ fontWeight: 'bold', marginBottom: '4px' }}>
                        {column.text}
                    </label>
                    <input
                        id={`filter-${column.dataField}`}
                        type="text"
                        placeholder="Filtrar por Estado..."
                        onChange={e => onFilter(e.target.value)}
                        className="form-control"
                    />
                </div>
            ),
            headerFormatter: customHeader,
            footer: ''
        },
        {
            dataField: 'aceptado_por_cc',
            text: 'Aceptado por CC',
            sort: true,
            headerStyle: { minWidth: 250, textAlign: 'center' }, // Centra el encabezado
            style: { textAlign: 'center' },
            filter: textFilter({ placeholder: '' }),
            filterRenderer: (onFilter, column) => (
                <div className="form-group" style={{ display: 'flex', flexDirection: 'column' }}>
                    <label htmlFor={`filter-${column.dataField}`} style={{ fontWeight: 'bold', marginBottom: '4px' }}>
                        {column.text}
                    </label>
                    <input
                        id={`filter-${column.dataField}`}
                        type="text"
                        placeholder="Filtrar por Aceptado por CC..."
                        onChange={e => onFilter(e.target.value)}
                        className="form-control"
                    />
                </div>
            ),
            headerFormatter: customHeader,
            footer: ''
        },
        {
            dataField: 'acciones',
            text: 'Acciones',
            formatter: (cell, row) => (

                <Box display="flex" gap={1} justifyContent="center">
                    <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        disabled={row.id_stock_identificado != null ? true : row.id_usuario == user.id_usuario ? false : true}
                        onClick={() => handleOpenModalEditar(row)}
                        sx={{ flex: 1 }}
                    >
                        Editar
                    </Button>
                    <Button
                        variant="contained"
                        color="error"
                        size="small"
                        //disabled={row.id_stock_identificado!=null?true:row.id_usuario == user.id_usuario?false:true}
                        disabled={
                            row.id_stock_identificado != null
                                ? true
                                : usuariosAutorizados.includes(user.id_usuario)
                                    ? false
                                    : true
                        }

                        onClick={() => handleOpenModal(row)}
                        sx={{ flex: 1 }}
                    >
                        Completar
                    </Button>
                </Box>

            )
        }
    ]


    function indication() {

        if (data?.length > 0) {
            return <h4
                style={{
                    background: 'white',
                    textAlign: 'left',
                    color: 'red'
                }}
            >No se econtraron resultados</h4>
        } else {
            return <h4
                style={{
                    background: 'white',
                    textAlign: 'left',
                    color: 'red'
                }}
            ></h4>
        }
    }

    const filtrarColumnas = (datos, columnas) => {
        return datos.map(row => {
            const nuevoRow = {};
            columnas.forEach(col => {
                nuevoRow[col] = row[col];
            });
            return nuevoRow;
        });
    };

    const descargarExcel = async () => {
        const columnasDeseadas = [
            'responsable', 'razon_social', 'fecha', 'hora', 'no_placa_transporte', 'nombre_piloto',
            'descargado_por', 'cantidad', 'producto', 'proveedor', 'fecha_de_vencimiento',
            'no_de_lote', 'peso_neto', 'id_stock_identificado', 'peso_factura',
            'peso_bascula', 'peso_sap', 'orden_compra', 'empaque', 'estado', 'aceptado_por_cc'
        ];

        const datosFiltrados = filtrarColumnas(data, columnasDeseadas);

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Datos');
        worksheet.properties.showGridLines = false;


        // 📐 Definir ancho de columnas para evitar desbordes
        worksheet.columns = new Array(20).fill(null).map(() => ({ width: 18 }));

        // 🖼️ Insertar logo institucional (base64 PNG)
        const logoBase64 = 'data:image/png;base64,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'; // reemplaza con tu logo real
        const imageId = workbook.addImage({
            base64: logoBase64,
            extension: 'png',
        });
        worksheet.properties.showGridLines = false;
        worksheet.addImage(imageId, {
            tl: { col: 0.96, row: 0 },
            ext: { width: 240, height: 50 }
        });

        worksheet.mergeCells('A1:B3');
        worksheet.getCell('A1:B3').border = {
            top: { style: 'thin', color: { argb: 'FF000000' } },
            left: { style: 'thin', color: { argb: 'FF000000' } },
            bottom: { style: 'thin', color: { argb: 'FF000000' } },
            right: { style: 'thin', color: { argb: 'FF000000' } }
        };

        // 🧩 Encabezado institucional con celdas combinadas
        worksheet.mergeCells('C1:R1');
        worksheet.getCell('C1').value = 'FORMATO';
        worksheet.getCell('C1').alignment = { horizontal: 'center', vertical: 'middle' };
        worksheet.getCell('C1').font = { bold: true, name: 'Arial', size: 12 };
        worksheet.getCell('C1:R1').border = {
            top: { style: 'thin', color: { argb: 'FF000000' } },
            left: { style: 'thin', color: { argb: 'FF000000' } },
            // bottom: { style: 'thin', color: { argb: 'FF000000' } },
            right: { style: 'thin', color: { argb: 'FF000000' } }
        };

        worksheet.mergeCells('S1:U1');
        worksheet.getCell('S1').value = 'Código: PDS-CC-PR-001';
        worksheet.getCell('S1').alignment = { horizontal: 'center', vertical: 'middle' };
        worksheet.getCell('S1').font = { bold: true, name: 'Arial', size: 10 };
        worksheet.getCell('S1:U1').border = {
            top: { style: 'thin', color: { argb: 'FF000000' } },
            left: { style: 'thin', color: { argb: 'FF000000' } },
            bottom: { style: 'thin', color: { argb: 'FF000000' } },
            right: { style: 'thin', color: { argb: 'FF000000' } }
        };

        worksheet.mergeCells('C2:R3');
        worksheet.getCell('C2:R3').value = 'INGRESO DE MATERIA PRIMA';
        worksheet.getCell('C2:R3').alignment = { horizontal: 'center', vertical: 'middle' };
        worksheet.getCell('C2:R3').font = { bold: true, name: 'Arial', size: 12 };
        worksheet.getCell('C2:R3').border = {
            //top:    { style: 'thin', color: { argb: 'FF000000' } },
            left: { style: 'thin', color: { argb: 'FF000000' } },
            bottom: { style: 'thin', color: { argb: 'FF000000' } },
            right: { style: 'thin', color: { argb: 'FF000000' } }
        };

        worksheet.mergeCells('S2:U2');
        worksheet.getCell('S2').value = 'Versión: 003';
        worksheet.getCell('S2').alignment = { horizontal: 'center', vertical: 'middle' };
        worksheet.getCell('S2').font = { bold: true, name: 'Arial', size: 10 };
        worksheet.getCell('S2:U2').border = {
            top: { style: 'thin', color: { argb: 'FF000000' } },
            left: { style: 'thin', color: { argb: 'FF000000' } },
            bottom: { style: 'thin', color: { argb: 'FF000000' } },
            right: { style: 'thin', color: { argb: 'FF000000' } }
        };

        worksheet.mergeCells('S3:U3');
        worksheet.getCell('S3').value = 'Fecha: 11/12/2014';
        worksheet.getCell('S3').alignment = { horizontal: 'center', vertical: 'middle' };
        worksheet.getCell('S3').font = { bold: true, name: 'Arial', size: 10 };
        worksheet.getCell('S3:U3').border = {
            top: { style: 'thin', color: { argb: 'FF000000' } },
            left: { style: 'thin', color: { argb: 'FF000000' } },
            bottom: { style: 'thin', color: { argb: 'FF000000' } },
            right: { style: 'thin', color: { argb: 'FF000000' } }
        };

        // 🧱 Espacio visual adicional
        worksheet.addRow([]);

        // 📊 Insertar encabezado de columnas
        const headerRow = worksheet.addRow(columnasDeseadas);
        headerRow.font = { bold: true };
        headerRow.alignment = { horizontal: 'center' };

        // 📥 Insertar datos
        datosFiltrados.forEach(obj => {
            const fila = columnasDeseadas.map(col => obj[col]);
            worksheet.addRow(fila);
        });

        worksheet.columns.forEach(column => {
            let maxLength = 10; // ancho mínimo por defecto
            column.eachCell({ includeEmpty: true }, cell => {
                const valor = cell.value ? cell.value.toString() : '';
                const longitud = valor.length;
                if (longitud > maxLength) {
                    maxLength = longitud;
                }
            });
            column.width = maxLength + 2; // margen adicional para evitar corte visual
        });

        // 💾 Exportar archivo
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });

        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `PDS_CC_PR_001_del_${formatearFecha(fechaInicio)}_al_${formatearFecha(fechaFin)}.xlsx`;
        a.click();
        URL.revokeObjectURL(url);
    };

    const descargarPDF = () => {
        /* const elemento = tablaRef.current;
       
         const opciones = {
           margin: 0.5,
           filename: 'tabla_resultados.pdf',
           image: { type: 'jpeg', quality: 0.98 },
           html2canvas: { scale: 3 }, // Aumenta la calidad visual
           jsPDF: {
             unit: 'pt', // puntos tipográficos
             format: [4000, 900], // 👈 Hoja personalizada: muy amplia en horizontal
             orientation: 'landscape'
           }
         };
       
         html2pdf().set(opciones).from(elemento).save();*/
    };

    const rowStyle = (row, rowIndex) => ({
        //backgroundColor: rowIndex % 2 === 0 ? '#3d5fd1ff' : '#f3f5f0ff',
        backgroundColor: rowIndex % 2 === 0 ? '#F2F2F2' : '#FFFFFF',
        fontWeight: 'bold'
    });

    const cerrarSesion = () => {
        sessionStorage.clear();
        sessionStorage.setItem("token", null)
        navigate('/login')
    }

    const goMenu = () => {
        sessionStorage.clear();
        sessionStorage.setItem("token", null)
        user.codigo_usuario = null
        navigate('/menu-categorias')
    }


    const textFieldStyles = {
        '& .MuiInputBase-root': {
            backgroundColor: '#f5f5f5',
            borderRadius: '8px',
        },
        '& .MuiInputBase-input': {
            padding: '10px',
            fontWeight: 'bold',
            color: '#3d5fd1',
        },
        '& .MuiInputLabel-root': {
            color: '#7f9251',
            fontWeight: 'bold',
        },
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#3d5fd1',
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#7f9251',
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#7f9251',
        }
    };


    const getRespuestaProducto = async () => {



        setRespuestaProducto([])

        const parametros = {

            "id_pregunta": 145,
            "id_formulario_realizado": 714

        }

        console.log("Parametros de getRespuesta: ", parametros)

        try {

            const headers = {
                'Content-Type': 'application/json',
            };

            const url = 'https://' + user.ip + user.puerto;

            const data = await fetch(url + '/formulario_sin_finalizar/obtener_respuesta_lista',
                {
                    method: 'POST',
                    headers,
                    body: JSON.stringify(parametros)

                });

            const datos = await data?.json()

            let respuesta = datos?.resultado;

            setRespuestaProducto(respuesta)

            console.log("Respuesta producto: ", respuesta)

        } catch (error) {


            console.log("Error al obtener respuesta producto: ", error)
        }



    }


    const getRespuestaProveedor = async () => {



        setRespuestaProveedor([])

        const parametros = {

            "id_pregunta": 146,
            "id_formulario_realizado": 714

        }

        console.log("Parametros de getRespuesta: ", parametros)

        try {

            const headers = {
                'Content-Type': 'application/json',
            };

            const url = 'https://' + user.ip + user.puerto;

            const data = await fetch(url + '/formulario_sin_finalizar/obtener_respuesta_lista',
                {
                    method: 'POST',
                    headers,
                    body: JSON.stringify(parametros)

                });

            const datos = await data?.json()

            let respuesta = datos?.resultado;

            setRespuestaProveedor(respuesta)

            console.log("Respuesta proveedor: ", respuesta)

        } catch (error) {


            console.log("Error al obtener respuesta proveedor: ", error)
        }


    }


    useEffect(() => {

        getRespuestaProducto();
        getRespuestaProveedor();



    }, []);

    return (
        <Container maxWidth="xl" sx={{ p: 2 }}>
            {/* Encabezado */}
            <Box sx={{ bgcolor: 'white', p: 2, borderRadius: 2, mb: 3 }}>
                <Grid container spacing={2} sx={{ bgcolor: 'white', borderRadius: 2, p: 2, textAlign: 'center', justifyContent: 'space-between' }}>
                    {/* Título a la izquierda */}
                    <Grid item xs={12} md={8}>
                        <Box sx={{ bgcolor: 'green', borderRadius: 2, p: 2, textAlign: 'center' }}>
                            <Typography variant="h4" color="white" fontWeight="bold">PDS-CC-FR-001</Typography>
                            <Typography variant="h6" color="white">Ingreso de Materia Prima</Typography>
                            <Typography variant="h6" color="white">Versión 1</Typography>
                        </Box>
                    </Grid>
                    {/* Botones alineados a la derecha */}
                    <Grid item xs={12} md={4}>
                        <Box sx={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            gap: 2,
                            flexWrap: 'wrap',
                            flexDirection: { xs: 'column', md: 'row' }
                        }}>
                            <Button
                                variant="contained"
                                startIcon={<HomeIcon />}
                                onClick={goMenu}
                                sx={{ minHeight: '56px' }}
                            >
                                Menú Principal
                            </Button>
                            <Button
                                variant="contained"
                                color="success"
                                startIcon={<ExitToAppIcon />}
                                onClick={cerrarSesion}
                                sx={{ minHeight: '56px' }}
                            >
                                Cerrar Sesión
                            </Button>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
            {/* Filtros y acciones */}
            <Box
                sx={{
                    border: '1px solid #0c0034',
                    borderRadius: '0.25em',
                    p: 3,
                    mb: 3,
                    bgcolor: 'white'
                }}
            >
                <Grid container spacing={2} alignItems="stretch" sx={{ justifyContent: 'space-between' }}>
                    {/* Fecha Inicio */}
                    <Grid item xs={12} sm={6} md={3}>
                        <TextField
                            fullWidth
                            label="Fecha Inicio"
                            type="date"
                            value={fechaInicio}
                            onChange={(e) => setFechaInicio(e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            sx={{ height: '100%' }}
                        />
                    </Grid>
                    {/* Fecha Fin */}
                    <Grid item xs={12} sm={6} md={3}>
                        <TextField
                            fullWidth
                            label="Fecha Fin"
                            type="date"
                            value={fechaFin}
                            onChange={(e) => setFechaFin(e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            sx={{ height: '100%' }}
                        />
                    </Grid>
                    {/* Consultar */}
                    <Grid item xs={12} sm={6} md={3}>
                        <Button
                            fullWidth
                            variant="contained"
                            startIcon={<SearchIcon />}
                            onClick={consultarDatos}
                            sx={{ height: '100%', minHeight: '56px' }}
                        >
                            Consultar
                        </Button>
                    </Grid>
                    {/* Descargar Excel */}
                    <Grid item xs={12} sm={6} md={3}>
                        <Button
                            fullWidth
                            variant="contained"
                            color="success"
                            startIcon={<DownloadIcon />}
                            onClick={descargarExcel}
                            sx={{ height: '100%', minHeight: '56px' }}
                        >
                            Descargar Excel
                        </Button>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        {

                            /*
    
                            <Button
                                fullWidth
                                variant="contained"
                                color="warning"
                                startIcon={<DownloadIcon />}
                                onClick={descargarPDF}
                                sx={{ height: '100%', minHeight: '56px' }}
                            >
                                Descargar PDF
                            </Button>
    
                            */

                        }
                    </Grid>
                </Grid>
            </Box>

            {/* Resultados */}
            <Typography variant="h6" sx={{
                borderRadius: '0.25em',
                textAlign: 'center',
                color: '#e9e6f1ff',
                border: '1px solid',
                p: 1,
                mt: 4,
                bgcolor: '#0c0034'
            }}>
                RESULTADOS
            </Typography>

            {/* Tabla */}
            <TableContainer ref={tablaRef} sx={{
                maxHeight: "100vh",
                overflowY: "auto",
                mb: 10,
                '& thead': {
                    position: 'sticky',
                    top: 0,
                    bgcolor: '#ffffff',
                    zIndex: 1
                }
            }}>
                <BootstrapTable
                    keyField='rownum'
                    data={data || []}
                    columns={columns}
                    bootstrap4
                    striped
                    hover
                    noDataIndication={indication}
                    loading
                    filter={filterFactory()}
                    rowStyle={rowStyle}
                />
            </TableContainer>

            {/* Modal */}
            <Modal open={openModal} onClose={handleCloseModal} closeAfterTransition>
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        bgcolor: 'background.paper',
                        borderRadius: 2,
                        boxShadow: 24,
                        p: { xs: 2, sm: 3 },
                        width: { xs: '90%', sm: 500 },
                        maxHeight: '90vh',
                        overflowY: 'auto',
                    }}
                >
                    <Typography variant="h6" mb={2}>Completar Registro</Typography>
                    <TextField
                        label="ID Stock Identificado"
                        fullWidth
                        margin="normal"
                        value={selectedRow?.id_stock_identificado || ''}
                        onChange={(e) =>
                            setSelectedRow(prev => ({ ...prev, id_stock_identificado: e.target.value }))
                        }
                    />
                    <TextField
                        label="Peso Báscula"
                        fullWidth
                        margin="normal"
                        value={selectedRow?.peso_bascula || ''}
                        onChange={(e) =>
                            setSelectedRow(prev => ({ ...prev, peso_bascula: e.target.value }))
                        }
                    />
                    <TextField
                        label="Peso SAP"
                        fullWidth
                        margin="normal"
                        value={selectedRow?.peso_sap || ''}
                        onChange={(e) =>
                            setSelectedRow(prev => ({ ...prev, peso_sap: e.target.value }))
                        }
                    />
                    <Box mt={2} display="flex" justifyContent="flex-end">
                        <Button onClick={handleCloseModal} sx={{ mr: 1 }}>Cancelar</Button>
                        <Button
                            variant="contained"
                            color="success"
                            onClick={() => {
                                guardarCamposRecursivamente(camposDeInteres);
                                handleCloseModal();
                            }}
                        >
                            Guardar
                        </Button>
                    </Box>
                </Box>
            </Modal>

            <Modal open={openModalEditar} onClose={handleCloseModalEditar} closeAfterTransition>
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        bgcolor: "background.paper",
                        borderRadius: 2,
                        boxShadow: 24,
                        p: { xs: 2, sm: 3 },
                        width: { xs: "90%", sm: 500 },
                        maxHeight: "90vh",
                        overflowY: "auto"
                    }}
                >
                    <Typography variant="h6" mb={2}>
                        Editar Registro
                    </Typography>

                    <TextField
                        label="Cantidad"
                        fullWidth
                        margin="normal"
                        value={selectedRowEditar?.cantidad || ""}
                        onChange={(e) =>
                            setSelectedRowEditar((prev) => ({ ...prev, cantidad: e.target.value }))
                        }
                    />

                    <TextField
                        label="Producto"
                        fullWidth
                        InputProps={{ readOnly: true }}
                        margin="normal"
                        value={selectedRowEditar?.producto || ""}
                        onChange={(e) =>
                            setSelectedRowEditar((prev) => ({ ...prev, producto: e.target.value }))
                        }
                    />

                    <TextField
                        select
                        label="Nuevo Producto"
                        fullWidth
                        margin="normal"
                        value={respuestaSelectedProducto}
                        onChange={(e) => setRespuestaSelectedProducto(e.target.value)}
                    >
                        <MenuItem value="" disabled>
                            Selecciona un producto...
                        </MenuItem>
                        {Array.isArray(respuestaProductoArray) &&
                            respuestaProductoArray.map((item, index) => (
                                <MenuItem key={item.key ?? index} value={item.key}>
                                    {item.value}
                                </MenuItem>
                            ))}
                    </TextField>



                    <TextField
                        label="Proveedor"
                        fullWidth
                        InputProps={{ readOnly: true }}
                        margin="normal"
                        value={selectedRowEditar?.proveedor || ""}
                        onChange={(e) =>
                            setSelectedRowEditar((prev) => ({ ...prev, proveedor: e.target.value }))
                        }
                    />

                    <TextField
                        select
                        label="Nuevo Proveedor"
                        fullWidth
                        margin="normal"
                        value={respuestaSelectedProveedor}
                        onChange={(e) => setRespuestaSelectedProveedor(e.target.value)}
                    >
                        <MenuItem value="" disabled>
                            Selecciona un proveedor...
                        </MenuItem>
                        {Array.isArray(respuestaProveedorArray) &&
                            respuestaProveedorArray.map((item, index) => (
                                <MenuItem key={item.key ?? index} value={item.key}>
                                    {item.value}
                                </MenuItem>
                            ))}
                    </TextField>

                    <TextField
                        label="Fecha de Vencimiento"
                        fullWidth
                        margin="normal"
                        value={selectedRowEditar?.fecha_de_vencimiento || ""}
                        onChange={(e) =>
                            setSelectedRowEditar((prev) => ({
                                ...prev,
                                fecha_de_vencimiento: e.target.value
                            }))
                        }
                    />

                    <TextField
                        label="No. Lote"
                        fullWidth
                        margin="normal"
                        value={selectedRowEditar?.no_de_lote || ""}
                        onChange={(e) =>
                            setSelectedRowEditar((prev) => ({ ...prev, no_de_lote: e.target.value }))
                        }
                    />

                    <TextField
                        label="Peso Factura"
                        fullWidth
                        margin="normal"
                        value={selectedRowEditar?.peso_factura || ""}
                        onChange={(e) =>
                            setSelectedRowEditar((prev) => ({ ...prev, peso_factura: e.target.value }))
                        }
                    />

                    <TextField
                        label="Peso Neto"
                        fullWidth
                        margin="normal"
                        value={selectedRowEditar?.peso_neto || ""}
                        onChange={(e) =>
                            setSelectedRowEditar((prev) => ({ ...prev, peso_neto: e.target.value }))
                        }
                    />

                    <TextField
                        label="Orden Compra"
                        fullWidth
                        margin="normal"
                        value={selectedRowEditar?.orden_compra || ""}
                        onChange={(e) =>
                            setSelectedRowEditar((prev) => ({ ...prev, orden_compra: e.target.value }))
                        }
                    />

                    <TextField
                        label="Razón Social"
                        fullWidth
                        margin="normal"
                        value={selectedRowEditar?.razon_social || ""}
                        onChange={(e) =>
                            setSelectedRowEditar((prev) => ({ ...prev, razon_social: e.target.value }))
                        }
                    />

                    <Box mt={2} display="flex" justifyContent="flex-end">
                        <Button onClick={handleCloseModalEditar} sx={{ mr: 1 }}>
                            Cancelar
                        </Button>
                        <Button
                            variant="contained"
                            color="success"
                            onClick={() => {
                                guardarCamposRecursivamenteEdicion(camposDeInteresEdicion);
                                handleCloseModalEditar();
                            }}
                        >
                            Guardar Edición
                        </Button>
                    </Box>
                </Box>
            </Modal>
        </Container>
    );
}

/*
const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: '#f5f5f5',
        paddingHorizontal: 20,
        paddingVertical: 30,
    },
    texto: {
        color: '#333',
        fontSize: 18,
        fontWeight: 'bold',
        marginBottom: 10,
        marginTop: 20,
    },
    in: {
        backgroundColor: '#fff',
        borderRadius: 10,
        borderWidth: 1,
        borderColor: '#ccc',
        padding: 15,
        fontSize: 16,
        height: 120,
        textAlignVertical: 'top',
        marginBottom: 20,
    },
    button1: {
        backgroundColor: '#7ebd16',
        width: '100%',
        height: 55,
        borderRadius: 25,
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: 20,
        elevation: 4,
    },
    button2: {
        backgroundColor: '#bd3316',
        width: '100%',
        height: 55,
        borderRadius: 25,
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: 20,
        elevation: 4,
    },
    buttonText: {
        color: '#fff',
        fontSize: 18,
        fontWeight: 'bold',
    },
    selectBox: {
        backgroundColor: '#fff',
        borderRadius: 10,
        elevation: 2,
        paddingHorizontal: 10,
        marginBottom: 20,
    },
    selectDropdown: {
        backgroundColor: '#fff',
        borderRadius: 10,
        elevation: 2,
    },
    selectItem: {
        paddingVertical: 10,
    },
    selectText: {
        fontSize: 16,
        color: '#333',
    },
    selectInput: {
        fontSize: 16,
        color: '#333',
    },
});
*/